import { render } from "./AnnotationsListItem.vue?vue&type=template&id=178fd50a&scoped=true"
import script from "./AnnotationsListItem.vue?vue&type=script&lang=js"
export * from "./AnnotationsListItem.vue?vue&type=script&lang=js"

import "./AnnotationsListItem.vue?vue&type=style&index=0&id=178fd50a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178fd50a"]])

export default __exports__